import { CommerceCategory, LoadingStatus } from '@api/types';
import { BackgroundImage, LoadingSkeleton, SmartLink } from '@components';
import { Typography, styled } from '@mui/material';
import { breakpoints, palette } from '@themes/theme.helpers';

// STYLES
//--------
const CategoryCardWrapper = styled('div')`
  background-color: ${palette.background('paper')};
  text-align: center;
  overflow: hidden;
  max-width: 400px;
  border-radius: 4px;
  .title {
    font-weight: 800;
    letter-spacing: 0.01em;
    color: ${palette.common('white')};
    transition: font-size 200ms linear;
    text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.5);

    ${breakpoints.up('xs')} {
      font-size: 18px;
    }
    ${breakpoints.up('sm')} {
      font-size: 30px;
    }
    ${breakpoints.up('lg')} {
      font-size: 32px;
    }
  }

  .background-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-size: cover;
    padding: 12px 0;
    cursor: pointer;
    transition: transform 0.3s;

    ${breakpoints.up('sm')} {
      padding: 12px;
      height: 230px;
    }

    ${breakpoints.up('md')} {
      &:hover {
        transform: scale(110%);
      }
    }

    p {
      text-align: center;
    }
  }
`;

// TYPES
//-------
export type CategoryCardProps = LoadingStatus & {
  data?: CommerceCategory;
};

// COMPONENTS
//------------

/**
 * Product Card for Product Listing Block
 */
export const CategoryCard = ({ data = {}, isLoading }: CategoryCardProps) => {
  const { name, image, contentLink } = data;
  return (
    <CategoryCardWrapper className='category-card'>
      <SmartLink href={contentLink?.url}>
        <BackgroundImage
          image={image}
          className='background-image'
          isLoading={isLoading}
          resizerParams={{ width: 400, quality: 95, format: 'webp' }}
        >
          <Typography className='title'>{isLoading ? <LoadingSkeleton /> : name}</Typography>
        </BackgroundImage>
      </SmartLink>
    </CategoryCardWrapper>
  );
};
